import Entity from "./entity";
import Item from "./item";
import Description from "./description";

class Weapon {
  static melee(glyph, name, description, damage, quality) {
    return Weapon.make(glyph, name, description, "melee", damage, quality);
  }

  static ranged(glyph, name, description, ammo, quality) {
    return Weapon.make(glyph, name, description, "ranged", ammo, quality);
  }

  static make(glyph, name, description, type, damageOrAmmo, quality) {
    return new Entity(null, null, glyph, name, {
      description: new Description(description),
      item: new Item(quality),
      weapon: new Weapon(type, damageOrAmmo)
    });
  }

  constructor(type, damageOrAmmo) {
    this.type = type;
    if (this.type == "melee") {
      this.damage = damageOrAmmo;
    } else {
      this.damage = 1;
      this.ammunition = damageOrAmmo;
    }
  }
}

export default Weapon;
